<div *ngIf="showModelOverlay" class="d-flex flex-column model-box model-overlay px-p-10">
    <div class="d-flex flex-row model-overlay-controls">
        <div>
            <div>
                <span class="font-weight-bold">Rollover</span>
            </div>
            <div class="d-flex flex-row px-mt-10">
                <div>
                    <input type="radio" id="modelRollOverControl1" name="rolloverToCash"
                           [(ngModel)]="modellingConfig.rolloverToCash" [value]="true">
                    <label for="modelRollOverControl1">Rollover to cash</label>
                </div>
                <div class="px-ml-20">
                    <input type="radio" id="modelRollOverControl2" name="rolloverToCash"
                           [(ngModel)]="modellingConfig.rolloverToCash" [value]="false">
                    <label for="modelRollOverControl2">No rollover</label>
                </div>
            </div>
        </div>
        <div class="px-pl-20 bl-vivier-grey"
             [ngClass]="{'w-90': pageUrl === '/overview', 'px-pr-20' : pageUrl.indexOf('entitySummary') < 0}">
            <div>
                <span class="font-weight-bold">Tall Probability</span>
            </div>
            <div class="d-flex flex-row px-mt-10">
                <div>
                    <input type="radio" id="modelTailToggleControl1" name="setForGroup"
                           [(ngModel)]="modellingConfig.setForGroup" [value]="true">
                    <label for="modelTailToggleControl1">Set for group</label>
                </div>
                <div class="px-ml-20">
                    <input type="radio" id="modelTailToggleControl2" name="setForGroup"
                           [(ngModel)]="modellingConfig.setForGroup" [value]="false">
                    <label for="modelTailToggleControl2">Set for each legal
                        entity</label>
                </div>
            </div>
            <div class="d-flex flex-column px-mt-11" [ngClass]="{'entity-tail-config-container': !modellingConfig.setForGroup }">
                <app-time-range-tail-config [class.d-none]="!modellingConfig.setForGroup" [entityTailConfig]="groupTailConfig"
                ></app-time-range-tail-config>
                <app-entity-tail-configs [class.d-none]="modellingConfig.setForGroup"
                                         [entityTailConfigs]="modellingConfig.entityTailConfigs"></app-entity-tail-configs>
            </div>
        </div>
        <!--<div class="px-pl-20 bl-vivier-grey trade-model-list-column" *ngIf=" pageUrl.indexOf('entitySummary') >= 0">-->
        <div class="px-pl-20 bl-vivier-grey trade-model-list-column" >
            <ng-container *ngIf="enableModels">
                <div>
                    <span class="font-weight-bold">Models</span>
                </div>
                <div class="d-flex px-mt-10">
                    <button class="btn btn-sm btn-basic px-mr-5" (click)="onEditTrade()" [disabled]="!canEdit()">
                        EDIT
                    </button>
                    <button class="btn btn-sm btn-basic px-mr-5" [disabled]="!selectedModel">
                        COPY
                    </button>
                    <button class="btn btn-sm btn-basic px-mr-5" (click)="onDeleteTrade()" [disabled]="!canEdit()">
                        DELETE
                    </button>
                    <button class="btn btn-sm btn-basic px-mr-5" (click)="onTradeExecuted()" [disabled]="true || !selectedModel">
                        TRADE EXECUTED
                    </button>
                    <button class="btn btn-sm btn-basic" (click)="refreshModelList.emit(true)">
                        REFRESH
                    </button>

                    <button class="btn btn-sm btn-basic ms-auto" (click)="onCreateNew()">
                        NEW
                    </button>
                </div>
                <div class="px-mt-10 radio-group-table">
                    <div *ngIf="tradeDataLoading" class="px-p-20 font-weight-bold">
                        Data loading, please wait...
                    </div>
                    <div *ngIf="!tradeDataLoading">
                        <table>
                            <tr (click)="onNoModelSelectionChange()">
                                <td class="px-px-10 px-w-40">
                                    <input type="radio" name="modelsRadioGroup" value=""
                                           [checked]="!selectedModel"
                                           (change)="onNoModelSelectionChange()"
                                           class="align-middle"></td>
                                <td>
                                    <div class="px-py-10">
                                        None
                                    </div>
                                </td>
                            </tr>
                            <tr *ngFor="let item of trades; let i = index" (click)="onModelSelectionChange(item)"
                                [class.selected]="selectedModel && selectedModel.modelId === item.modelId">
                                <td class="px-px-10 px-w-40">
                                    <input type="radio" name="modelsRadioGroup"
                                           [value]="item.modelId"
                                           [checked]="selectedModel && selectedModel.modelId === item.modelId"
                                           (change)="onModelSelectionChange(item)"
                                           class="align-middle"></td>
                                <td class="px-py-10 ">
                                    <div class="d-flex align-items-center">
                                        <div class="me-auto">
                                            {{item.modelId?.substring(0, 8)}} : {{item.modelName}}
                                        </div>
                                        <div class="text-end px-pe-10">
                                            <div>
                                                {{item.userName}}
                                            </div>
                                            <div>
                                                {{item.status}}
                                            </div>
                                            <div *ngIf="item.status && item.status == modelStatus.completed">
                                                {{item.createdDate}}
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div class="d-flex flex-row-reverse px-pt-10 bt-vivier-grey px-mt-10">
        <button type="button" class="btn btn-sm btn-basic bnpp-btn px-w-75"
                (click)="onModelRun()"
                [disabled]="selectedModel && selectedModel.status && (selectedModel.status == modelStatus.pending || selectedModel.status == modelStatus.inProgress)">
            {{ (selectedModel && selectedModel.status && (selectedModel.status == modelStatus.completed)) ? 'OPEN' : 'RUN'}}
        </button>
    </div>
</div>
